import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';

// screen
import type { ConfirmationCode } from 'modules/confirmation-code/types';

interface Props {
  targetOrgId?: string;
  status?: string;
}

/** Danh sách Mã xác nhận (lọc theo trường / trạng thái). */
const useGetConfirmationCodes = ({ targetOrgId, status }: Props) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.confirmationCode, targetOrgId, status],
    queryFn: async (): Promise<ConfirmationCode[]> => {
      if (!service) return [];
      const res = await service.ConfirmationCodeController_list({
        queries: { targetOrgId, status },
      });
      return res?.data ?? [];
    },
    staleTime: 0,
    gcTime: 0,
  });
};

export default useGetConfirmationCodes;
